import React from 'react';
import { motion } from 'framer-motion';
import { CoffeeIcon } from 'lucide-react';
export function OpeningHook() {
  return <section className="bg-white py-20 px-6" data-id="element-148">
      <div className="max-w-3xl mx-auto text-center" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex justify-center mb-8" data-id="element-150">
          <div className="bg-[#FFF8F0] p-4 rounded-full text-[#E76F51]" data-id="element-151">
            <CoffeeIcon size={32} data-id="element-152" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 text-lg md:text-xl text-[#5C4B3A] leading-relaxed" data-id="element-153">
          <p className="font-heading text-2xl md:text-3xl text-[#2D6A4F] font-medium mb-8" data-id="element-154">
            Son las 5:15 de la mañana. El café aún no está listo y tú ya sientes
            el peso de la culpa sobre los hombros mientras miras una nevera
            medio vacía.
          </p>
          <p data-id="element-155">
            Sabes que no quieres enviarle otro paquete de galletas procesadas,
            pero la idea de prender la estufa y cocinar algo desde cero te agota
            antes de que empiece el día.
          </p>
          <div className="h-px w-24 bg-[#E76F51]/30 mx-auto my-8" data-id="element-156"></div>
          <p className="font-semibold text-[#2D6A4F]" data-id="element-157">
            No eres una mala madre por estar cansada. Eres una madre trabajadora
            atrapada en un sistema que te exige cocinar como si no tuvieras
            oficina y trabajar como si no tuvieras hijos.
          </p>
        </motion.div>
      </div>
    </section>;
}